import { DataModel } from "common/models/utility-models/base-model";

export class branchListModel extends DataModel
{
  override id: "";
  department_name: "";
  branchCategoryId: "";
  branchCatName: "";
}